import {Component, Inject, OnInit} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AdvanceSaleLevel} from "../../../../model/club-gigot/action-points/action-points-configuration.model";
import {ActionPointsService} from "../../../../service/club-gigot/action-points.service";
import {
    DialogActionPointsData
} from "../../../../model/club-gigot/action-points/dialog/dialog-action-points-data.model";
import {DialogData} from "../dialog-add-product-group/dialog-add-product-group.component";
import {
    ActionPointsAdvanceSaleResult
} from "../../../../model/club-gigot/action-points/action-points-advance-sale-result.model";

@Component({
  selector: 'kt-dialog-add-advance-sale-level',
  templateUrl: './dialog-add-advance-sale-level.component.html',
  styleUrls: ['./dialog-add-advance-sale-level.component.scss']
})
export class DialogAddAdvanceSaleLevelComponent implements OnInit {

    public advancedSaleLevelForm: FormGroup;
    public _isEditMode: boolean = false;
    constructor(private dialogRef: MatDialogRef<DialogAddAdvanceSaleLevelComponent>,
                private actionPointsService: ActionPointsService,
                @Inject(MAT_DIALOG_DATA)
                public data: AddLevelDialog) { }

    ngOnInit() {
        if (this.data.levels.length > 0) {
            this._isEditMode = true;
        }
        this.buildForms();
    }

    public buildForms(){
        this.advancedSaleLevelForm = new FormGroup({
            /*id : new FormControl((this.isEditMode && this.data.actionPointData !== undefined) ? this.data.actionPointData.id : null),
            name : new FormControl(this.isEditMode ? this.data.actionPointData.name : null, [Validators.required]),
            campaignsToNet: new FormControl(this.isEditMode ? this.data.actionPointData.campaignsToNet.toString() : null, [Validators.required]),
            endingCampaignSequence: new FormControl(this.isEditMode ? this.data.actionPointData.endingCampaignSequence.toString() : null, [Validators.required]),
            expirationPointsCampaignSequence: new FormControl(this.isEditMode ? (this.data.actionPointData.expirationPointsCampaignSequence - this.data.campaignSequence).toString() : null, [Validators.required]),
            reachId: new FormControl(this.isEditMode ? this.data.actionPointData.reachId : null)*/
            levels: new FormArray([], [Validators.required])
        });

        if(!this._isEditMode){
            this.addLevel();
        }else{
            this.addLevelsEdit();
        }

    }

    public addLevel(){
        let fa = this.advancedSaleLevelForm.controls['levels'] as FormArray;
        const formGroup = new FormGroup({
            points: new FormControl(null, [Validators.required]),
            minimum: new FormControl(null, [Validators.required, Validators.min(1)]),
            maximum: new FormControl(null, [Validators.required])
        });
        //formGroup.setValidators([this.validateFidelityPeriod(), this.validateFidelityPeriodMinimum()])
        fa.push(formGroup);
    }

    public addLevelsEdit(){
        let fa = this.advancedSaleLevelForm.controls['levels'] as FormArray;
        this.data.levels.forEach((level, index) => {
            const formGroup = new FormGroup({
                points: new FormControl(level.points, [Validators.required]),
                minimum: new FormControl(level.minProducts, [Validators.required, Validators.min(1)]),
                maximum: new FormControl(level.maxProducts, [Validators.required])
            });
            //formGroup.setValidators([this.validateFidelityPeriod(), this.validateFidelityPeriodMinimum()])
            fa.push(formGroup);
        });
    }

    public getLevels(): FormArray{
        return this.advancedSaleLevelForm.controls['levels'] as FormArray;
    }

    public addLevelForm(){
        this.addLevel();
    }

    public deleteLevel(index: number){
        let fa = this.advancedSaleLevelForm.controls['levels'] as FormArray;
        fa.removeAt(index);
    }

    public close() {
        this.dialogRef.close();
    }

    public onCreate() {
        let levelsForm = this.advancedSaleLevelForm.controls['levels'] as FormArray;
        let levelsArray = [];
        levelsForm.controls.forEach((levelForm: FormGroup, index) => {
            let level = new AdvanceSaleLevel(index + 1, levelForm.controls['points'].value, levelForm.controls['minimum'].value, levelForm.controls['maximum'].value);
            levelsArray.push(level);
        });

        this.actionPointsService.saveAdvanceSaleLevels(this.data.advanceSaleId, levelsArray).subscribe({
            next: (response) => {

            }
        });
        this.dialogRef.close(new ActionPointsAdvanceSaleResult(false, true));
    }
}

export interface AddLevelDialog{
    advanceSaleId: number;
    levels: AdvanceSaleLevel[];
}
